<template>
    <div>
        <v-container>
            <v-row>
                <v-col cols="12">
                    <div class="grey--text">
                        Posted On  {{ dateutils.utcToLocal(question.created_at).format('M MMM \'YY, hh:mm A') }}
                    </div>
                    <h1 class="mb-2">
                        <div v-html="highlight(question.title)">
                        </div>                        
                    </h1>
                    <h4 class="grey--text text--darken-2 font-weight-regular">
                        <div v-html="highlight(question.description)">
                        </div>
                    </h4>
                </v-col>
                <v-col cols="12">
                    <v-list-item v-if="question.patient" class="pl-0">
                        
                        <v-icon class="secondaryVariant--text font-40">
                            mdi-account-circle
                        </v-icon>
                        
                        <v-list-item-content class="ml-1">
                            <v-list-item-title
                                    v-html="question.patient.gender" style="text-transform: capitalize;"></v-list-item-title>
                            <v-list-item-subtitle
                                    v-html="question.patient.city"></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="12" v-if="question.specializations.length">
                    <h4 class="grey--text text--darken-3 mb-2 font-weight-regular">
                        Health Concern:
                    </h4>
                    <v-chip v-for="specialization in question.specializations" :key="specialization.id">
                        {{ specialization.name }}
                    </v-chip>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <v-divider></v-divider>
                    <h3 class="font-weight-regular mt-4">Answers ({{ question.total_answers }}) </h3>
                </v-col>
                <v-col col="12" sm="12" class="pt-0">
                    <v-list three-line>
                        <template v-for="answer in question.answers">
                            <v-list-item
                                    :key="answer.id"
                                    class="pl-0 "
                            >
                                <v-list-item-avatar @click="showDoctorProfile(answer.doctor)" class="pointer" v-if="!answer.doctor.profile_image_path">
                                    <v-icon class="secondaryVariant--text font-30 align-self-start mt-2" color="primary" style="font-size: 50px">mdi-account-circle</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-avatar @click="showDoctorProfile(answer.doctor)" class="pointer" v-else>
                                  <v-img :src="apiUrl+'/storage/'+answer.doctor.profile_image_path"></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content class="align-self-start ml-2">
                                    <v-list-item-title class="cursor-pointer" v-if = "answer.doctor" @click="showDoctorProfile(answer.doctor)">
                                        {{ answer.doctor.salutation }} {{ answer.doctor.name }}
                                        <div class="font-12 weight-regular mt-2 mb-4 text-left ">{{ dateutils.utcToLocal(answer.created_at).format('M MMM \'YY, hh:mm A') }}</div>
                                    </v-list-item-title>
                                    <v-list-item-title v-else >
                                        --
                                    </v-list-item-title>
                                    <v-list-item-subtitle style="line-clamp:unset;">
                                        {{ answer.response }}
                                    </v-list-item-subtitle>

                                </v-list-item-content>

                              
                            </v-list-item>
                            <v-divider :key="answer.id"></v-divider>
                        </template>
                    </v-list>
                </v-col>
                <v-col cols="12">
                    <div class="sharethis-inline-share-buttons"></div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "QuestionDetails",
        components: {},
        computed: {
            ...mapGetters([
                'accessToken',
                'userInfo'
            ]),
        },
        mounted() {
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', 'https://platform-api.sharethis.com/js/sharethis.js#property=601282879997ac0011195766&product=inline-share-buttons')
            recaptchaScript.setAttribute('aync', 'async');            
            document.head.appendChild(recaptchaScript)

            this.getQuestionDetails();
        },
        data() {
            return {
                apiUrl:process.env.VUE_APP_API_URL,
                question: {},
                questionId: '',
            }
        },
        methods: {
            highlight(text) {
                
                if(!this.$route.query.query) {
                    return text;
                }
                return text.replace(new RegExp(this.$route.query.query, "gi"), match => {
                    console.log("REPLACE")
                    return '<span class="highlightText">' + match + '</span>';
                });
            },
            getQuestionDetails() {
                this.axios
                    .get(`${process.env.VUE_APP_API_URL}/api/questions/${this.$route.params.id}`)
                    .then((response) => {
                        this.question = response.data.data;
                    }).catch((error) => {
                    console.log(error);
                });
            },
          showDoctorProfile(doctor) {
              
            let routeData = this.$router.resolve({name: 'DoctorDetails', params: {unique_no: doctor.unique_no, slug: this.getSlugFromString(doctor.name)}});            
            window.open(routeData.href, '_blank');
          },
        }
    }
</script>

<style>

</style>
